import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/group_applications',
  component: Management,
  redirect: '/group_applications/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/group_applications/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listGroupApplications
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/group_applications/ListTable'),
          meta: {
            auth: Auth.listGroupApplications,
            tabName: 'all'
          }
        },
        {
          path: 'pending',
          component: () => import('@/views/group_applications/ListTable'),
          meta: {
            auth: Auth.listGroupApplications,
            tabName: 'pending'
          }
        },
        {
          path: 'passed',
          component: () => import('@/views/group_applications/ListTable'),
          meta: {
            auth: Auth.listGroupApplications,
            tabName: 'passed'
          }
        },
        {
          path: 'rejected',
          component: () => import('@/views/group_applications/ListTable'),
          meta: {
            auth: Auth.listGroupApplications,
            tabName: 'rejected'
          }
        },
        {
          path: 'disabled',
          component: () => import('@/views/group_applications/ListTable'),
          meta: {
            auth: Auth.listGroupApplications,
            tabName: 'disabled'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/group_applications/New'),
      meta: {
        auth: Auth.createGroupApplication
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/group_applications/Edit'),
      meta: {
        auth: Auth.updateGroupApplication
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/group_applications/DetailLayout'),
      meta: {
        auth: Auth.showGroupApplication
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/group_applications/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showGroupApplication
          }
        }
      ]
    }
  ]
}
